/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";

export {
  fetchFortimanager,
  fetchCredentials,
} from "../../fwaas/request/request";

export type FetchSdwanHubListOpts = {
  limit?: number;
  offset?: number;
};

/**
 * GET /v1/kontroledge/bbaas/sdwan-hub
 * Lists SDWAN Hub services for the tenant (status, connections, customer).
 */
export function fetchSdwanHubList(
  api: AxiosInstance,
  tenantId: number,
  opts?: FetchSdwanHubListOpts
): Promise<AxiosResponse> {
  const params: Record<string, number> = { tenantId };
  if (opts?.limit != null) params.limit = opts.limit;
  if (opts?.offset != null) params.offset = opts.offset;
  return api.get("/kontroledge/bbaas/sdwan-hub", { params });
}
